import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from '@zurich/common/hooks';
import { Stack } from '@zurich/ui/atoms';
import { useIsDesktop } from '@zurich/ui/hooks';
import { Button, Card, CardContent, DataTableRow, DataTableRowContent, DataTableRowFooter, DataTableRowHeader, Tag, Typography, } from '@zurich/ui/legacy/components';
import { useAppImage, useAppLink, } from '@zurich/ui/legacy/hooks';
import { styled } from '@zurich/ui/legacy/utils';
import Motor from '../../images/Car_Digital_RGB.svg';
import Life from '../../images/Health_Heart_Digital_RGB.svg';
import ProductProtection from '../../images/Product_Protection_Digital_RGB.svg';
import NonMotor from '../../images/Protection_Digital_RGB.svg';
const getPolicyIcon = (policy) => {
    switch (policy) {
        case 'Motor':
            return Motor;
        case 'NonMotor':
            return NonMotor;
        case 'Life':
            return Life;
        default:
            return ProductProtection;
    }
};
// TODO move to libs/template, as it is only used there
export function PolicyListItem({ policy, data, policySegment, linkPathPrefix, simpleView, }) {
    const { t } = useTranslation();
    const AppLink = useAppLink();
    const AppImage = useAppImage();
    const isDesktop = useIsDesktop();
    // FIXME: routing shouldn´t be inside of the component
    const policyIdPath = `${linkPathPrefix ?? ''}/contract/${policy.id}`;
    // TODO: Clarify: sollte eigentlich anhand der state klar sein .
    function isPolicyActive(policy) {
        return policy.metadataObject?.state === 'policy' ? true : false;
    }
    const tagText = t(`policy.${isPolicyActive(policy) ? 'active' : 'inactive'}`);
    // TODO: use same/different translations? HBM/Customer portal
    const title = () => {
        return (_jsx(AppLink, { href: policyIdPath, children: _jsx(TypographyStyled, { variant: isDesktop ? 'subtitle1' : 'body2', children: _jsx(_Fragment, { children: simpleView ? (_jsxs(_Fragment, { children: [_jsx("strong", { children: `${policy.modelObject?.insuredObjects?.[0].insuredObjectType === 'Vehicle' ? `${(policy.modelObject?.insuredObjects?.[0]).model} ` : ''}${policy.metadataObject?.licensePlate ||
                                    policy.metadataObject?.riskDescription} ${policy.metadataObject?.productName}` }), ' ', policy.metadataObject?.policyNo] })) : (_jsxs(_Fragment, { children: [_jsx("strong", { children: policy.metadataObject?.policyNo }), ' ', policy.metadataObject?.productName] })) }) }) }, policy.id || policy.metadataObject?.policyNo));
    };
    const button = () => {
        return (_jsx(AppLinkStyled, { children: _jsx(AppLink, { href: policyIdPath, children: _jsx(Button, { variant: "outlined", size: isDesktop ? 'medium' : 'small', children: t('portal:policy.contractDetails') }) }, policy.id || policy.metadataObject?.policyNo) }));
    };
    return (_jsx(_Fragment, { children: isDesktop ? (_jsxs(DataTableRow, { rowGap: 3, striped: true, children: [_jsx(DataTableRowHeader, { image: _jsx(AppImage, { src: getPolicyIcon(policy.modelObject?.productCategory), alt: "product_category" }), tags: _jsx(Tag, { variant: isPolicyActive(policy) ? 'success' : 'error', children: tagText }), title: title() }), _jsx(DataTableRowContent, { data: data }), _jsxs(DataTableRowFooter, { children: [policySegment ? policySegment : _jsx("span", {}), button()] })] })) : (_jsx(Card, { children: _jsx(CardContent, { children: _jsxs(Stack, { gap: 1, children: [title(), _jsx(TagStyled, { small: true, variant: isPolicyActive(policy) ? 'success' : 'error', children: tagText }), _jsx(DataTableRowContent, { rowGap: 1, data: data }), policySegment ? policySegment : _jsx("span", {}), _jsx(Stack, { justifyContent: "flex-end", direction: "row", children: button() })] }) }) })) }));
}
const TagStyled = styled(Tag)({
    width: 'fit-content',
});
const AppLinkStyled = styled('div')({
    width: 'fit-content',
});
const TypographyStyled = styled(Typography)({
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
        textDecoration: 'underline',
    },
});
